module.exports = __webpack_public_path__ + "img/product-background.d840eb56.png";